import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import EvaluationTemplateCreateForm from './EvaluationTemplateCreateForm';

export default function EvaluationTemplateCreate(props) {
    return <EvaluationTemplateCreateForm storeUrl={storeUrl} editUrl={editUrl} />;
}

if (document.getElementById('createEvaluationTemplate')) {
    var root = document.getElementById('createEvaluationTemplate');
    ReactDOM.render(
        <App>
            <EvaluationTemplateCreate />
        </App>,
        root,
    );
}
